import styled from 'styled-components'

export const StyledWatchListLink = styled.a`
  .icon {
    margin-right: 0.4rem;
  }
`
